import Header from '../components/Header';
import Footer from '../components/Footer';
import ChatBar from '../components/ChatBar';
import PolicyLayout from './PolicyLayout';
import {
  ADDRESS,
  COMPANY_NAME,
  POLICY_UPDATED,
  SITE_DOMAIN,
  SITE_NAME,
  SUPPORT_EMAIL,
} from '../constants/site';

export default function RefundPolicy() {
  return (
    <div className="page">
      <Header />
      <PolicyLayout
        title="Refund Policy"
        updated={POLICY_UPDATED}
        intro={`This Refund Policy applies to any paid support services arranged through ${SITE_NAME} at ${SITE_DOMAIN}, operated by ${COMPANY_NAME}.`}
      >
        <h2>Support services</h2>
        <p>
          If you paid for a support session or related service and are not satisfied, contact us
          within 7 days of the charge. We will review your case and work toward a fair resolution.
        </p>

        <h2>Eligibility</h2>
        <ul>
          <li>Refund requests must include your name, contact details, and date of service.</li>
          <li>Services already fully delivered may not qualify for a full refund.</li>
          <li>Duplicate or erroneous charges will be corrected promptly.</li>
        </ul>

        <h2>Software purchases</h2>
        <p>
          Family Tree Maker software licenses purchased from third parties or publishers are subject
          to those vendors&apos; refund policies. We cannot issue refunds for software we did not sell
          directly.
        </p>

        <h2>How to request a refund</h2>
        <p>
          Email us at <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> or open live chat with
          your receipt details. We aim to respond within 2 business days.
        </p>

        <h2>Contact</h2>
        <p>
          {COMPANY_NAME}<br />
          {ADDRESS}<br />
          {SITE_DOMAIN}
        </p>
      </PolicyLayout>
      <Footer />
      <ChatBar />
    </div>
  );
}
